// api/models/plugins.ts
import { useApi } from '~/api'
import { defineService } from '~/api/models/helpers'
import type { AuthArgs } from '~/api/models/index'

const queries = {
  getAll: {
    queryFn: () => useApi().plugins.getAll(),
    queryKey: () => ['allPlugins']
  }
} as const

const mutations = {} as const

export type PluginModelService = ReturnType<typeof defineService<typeof queries, typeof mutations>>

export const registerService = (authArgs: AuthArgs): PluginModelService =>
  defineService(authArgs, { queries, mutations })
